import { render, staticRenderFns } from "./addCP.vue?vue&type=template&id=6771155c&"
import script from "./addCP.vue?vue&type=script&lang=js&"
export * from "./addCP.vue?vue&type=script&lang=js&"
import style0 from "./addCP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports